// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UxyOqKg3OTgbMC1XY6yF{flex-direction:column;align-items:flex-start;padding-top:24px;display:flex}.T2Xj7PstAPUKMSWKwhZJ{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `UxyOqKg3OTgbMC1XY6yF`,
	"alert": `T2Xj7PstAPUKMSWKwhZJ`
};
export default ___CSS_LOADER_EXPORT___;
